import { useQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
import type { BusinessDetail } from "@/api/types";

export function useBusiness(slug: string) {
  return useQuery({
    queryKey: ["businesses", slug],
    queryFn: () => api.get(`businesses/${slug}`).json<BusinessDetail>(),
    enabled: !!slug,
  });
}
